import BrandLogo from "../../utils/brands/BrandLogo.jsx";
import React, {useMemo} from "react";
import ReportingInfoTooltip from "../ReportingInfoTooltip.jsx";
import {useTranslation} from "react-i18next";
import {useMarketingColumns} from "../../pages/dashboard/MarketingChannelGrids/channelGridColumnSetup.js";

export default function GridSection({brand, title, children, gridType, titleContext = null}) {
    let {t} = useTranslation();

    let columns = useMarketingColumns(gridType);

    let tooltipContent = useMemo(
        () => {
            let generalTooltip = '';

            if (brand?.isAdSystem) {
                generalTooltip = t('tooltip.channel.general');
                if (brand?.slug === 'google') {
                    generalTooltip += ' ' + t('tooltip.channel.pmax');
                }
            }

            generalTooltip += '<br><br>' + t('tooltip.column.names') + ':<br><br><table>';

            // noinspection HtmlUnknownAttribute
            let tableRow = (short, long) => '<tr class="border-b-8 border-transparent">' +
                '<td class="text-right w-24">' + short + '</td>' +
                '<td class="px-2"> - </td>' +
                '<td class="w-64">' + long + '</td>' +
                '</tr>';

            for (let column of columns) {
                if (column.desc) {
                    generalTooltip += tableRow(column.header, column.desc);
                }
            }

            generalTooltip += '</table>';

            return generalTooltip;
        },
        [brand, gridType],
    );

    return <div
        className={
            'comp__roundedBox reporting-surface rounded-lg w-full mb-5' + ' ' +
            'bg-white dark:bg-slate-800' + ' ' +
            'border-slate-200 dark:border-slate-700' + ' ' +
            'text-slate-500 hover:text-slate-600 dark:text-slate-400 dark:hover:text-slate-300' + ' ' +
            'shadow-xl rounded-lg border-1'
        }>
        <div
            className={'flex min-h-12 gap-3 px-4 py-3 border-b border-slate-100 dark:border-slate-700 items-center'}>
            {brand && <BrandLogo brand={brand} size={6}/>}
            <h2 className={'text-sm font-semibold text-slate-900 dark:text-slate-100 flex gap-2'}>
                {title}
                {tooltipContent && (
                    <ReportingInfoTooltip size="lg" ariaLabel={t("reporting_lab.kpi.info_label", {defaultValue: "Vysvětlení metriky"})}>
                        <div className="text-xs text-gray-200">
                            <div dangerouslySetInnerHTML={{__html: tooltipContent}}></div>
                            {titleContext && <div className="mt-2 border-t border-slate-600 pt-2">{titleContext}</div>}
                        </div>
                    </ReportingInfoTooltip>
                )}
            </h2>
        </div>
        <div className={'datagrid-wrap rounded-b-lg overflow-hidden'}>
            {children}
        </div>
    </div>;
}
